var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-view-taskname',{attrs:{"value":_vm.value,"values":_vm.values,"model":_vm.model}})
}
var staticRenderFns = []

export { render, staticRenderFns }